import { Component, OnInit } from '@angular/core';

import { AnimationOptions } from 'ngx-lottie';
import { CleverTapConstents, ConstantData, LoanStatusConstant } from 'src/app/services/constants';
import { DialogBoxService } from 'src/app/services/dialog-box.service';
import { DialogBox } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent implements OnInit {
  popupVisible: boolean = true;

  popData!: DialogBox;
  loanDetails: any = {};
  dISBURSEMENTMsg: any = {};

  get applicant() {
    return this.loanDetails?.loanApplicantDetails.find((res: any) => res.mainApplicant);
  }

  constructor(private dialogservice: DialogBoxService, public util: UtilService) { }

  options: AnimationOptions = {
    path: this.util.redirectionUrl + ConstantData.compassLoader,
  }; 
  successOption:AnimationOptions = {
    path:this.util.redirectionUrl + ConstantData.successLoan,
  };
  ngOnInit(): void {

    this.dialogservice.dialoagState.subscribe((data: DialogBox) => {
      this.popData = data;
      this.popupVisible = this.popData.show;
      this.loanDetails = this.util.loanDetails;
      if (this.popData.isDisbursed) {
        if (this.loanDetails.statusId !== LoanStatusConstant.active) {
        this.util.cleverTapEventCall(CleverTapConstents.disbursement_initiated,{});
          this.dISBURSEMENTMsg = this.util.waitingResponse.find((data: any) => data.id === "DISBURSEMENT");
        } else {
          setTimeout(() => {
            this.popupVisible = false;
            this.util.route('welcome');
          }, 5000);

        }
      }



    })

  }

  submit() {
    this.popupVisible = false;
    this.popData.callBack && this.popData.callBack();
  }
  onClose() {
    this.popupVisible = false;
    this.popData.onClose && this.popData.onClose();
  }
}
